import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import ServiceLayout from '../components/ServiceLayout';

export default function SoftwareConsulting() {
  return (
    <Layout>
      <ServiceLayout
        title="Software Consulting"
        banner="/assets/images/banner/consulting.png"
        current="/software-consulting"
      >
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-brand-dark mb-4">Software Consulting</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              We specialize in providing tailored software consulting services to help businesses of all sizes harness the power of technology and achieve their goals. Our team of seasoned consultants brings strategic expertise to the table. We work closely with clients to understand their unique challenges and objectives, developing customized solutions that align with their business goals and drive measurable results.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none p-0">
              {['Expertise Access', 'Custom Solutions'].map((item) => (
                <li key={item} className="flex items-center gap-3 text-brand-dark/80 text-sm">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand/10 flex items-center justify-center">
                    <span className="icon-check-circle text-brand text-xs"></span>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <img src="consulting.jpg" alt="#" className="w-full rounded-2xl shadow-md" />

          <div>
            <p className="text-gray-600 leading-relaxed mb-6">
              In today's fast-paced world, innovation is key to staying ahead of the competition. Our consultants leverage the latest technologies and best practices to deliver innovative solutions that empower our clients to thrive in an ever-evolving marketplace.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { icon: 'icon-web-design', title: 'IT Consulting', desc: 'Gain insight and expertise with our IT consulting services, covering everything from infrastructure optimization to cybersecurity.' },
                { icon: 'icon-data', title: 'Collaborative Partnership', desc: 'We foster strong, collaborative partnerships with our clients founded on trust, transparency, and mutual respect.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5 border border-gray-100">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-brand flex items-center justify-center">
                    <span className={`${icon} text-white text-xl`}></span>
                  </div>
                  <div>
                    <h3 className="text-brand-dark font-bold font-heading mb-2">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="flex-1">
              <p className="text-gray-600 leading-relaxed">
                Our ultimate goal is to deliver tangible results that exceed our clients' expectations. Whether it's optimizing business processes, improving efficiency, or driving revenue growth, we are committed to helping our clients achieve measurable outcomes that make a real impact on their bottom line.
              </p>
            </div>
            <div className="flex-shrink-0 md:w-48">
              <img src="/assets/images/services/img2.png" alt="#" className="w-full rounded-xl shadow-sm" />
            </div>
          </div>
        </div>
      </ServiceLayout>
    </Layout>
  );
}
